// extracted by mini-css-extract-plugin
export default {"TestModalAuthFlow":"TestModalAuthFlow_TestModalAuthFlow__+BBnF","dialog":"TestModalAuthFlow_dialog__9YREL"};